<template>
  <transition name="pa-simple-fade" @enter="handleEnter">
    <div
     class="pa-message-additional-box pa-message-additional-box-check-application-status"
     :class="additionalClass"
     v-if="couldVisible"
     ref="contentBox"
    >
      <ListLoadingField :isLoading="isLoading" :boxHeight="boxHeight" />

      <p class="title-balloon" ref="titleBalloon">現在の申請状況は以下の通りです。</p>

      <div class="list-view-set">
        <ul class="list-view" :class="listViewClass">
          <li
          v-for="characterApplication in applicationList"
          :key="characterApplication.id"
          @click="handleClickItem(characterApplication.id)"
          >
            <ItemBanner
            :id="characterApplication.id"
            />
          </li>
        </ul>

        <div class="no-content-field" ref="noContent" v-if="isVisibleNoContent">
          <p class="text">現在受付中の申請はございません。</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {GetCharacterApplicationList} from '@/graphql/queries/CharacterApplication.graphql'

import ListLoadingField from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsCheckApplicationStatus/ListLoadingField.vue'

import ItemBanner from '@/components/Pages/Office/MessageApp/Additionals/MessageAdditionalsCheckApplicationStatus/ItemBanner.vue'

export default {
  props : {
    isDisabled  : {
      default: false,
    }
  },

  components : {
    ListLoadingField,
    ItemBanner,
  },

  data(){
    return {
      couldVisible        : false,

      applicationList     : [],
      paginateParameters  : {
        page      : null,
        lastPage  : null,
        total     : null,
        loaded    : false
      },

      isLoading           : false,

      additionalClass     : {
        'pa-message-additional-box-check-application-status-disabled' : false
      },

      listViewClass       : {
        'list-view-visible'  : false
      },

      isVisibleNoContent  : false,

      boxHeight           : 0
    };
  },

  watch : {
    isDisabled(value){
      this.additionalClass['pa-message-additional-box-check-application-status-disabled'] = value;
    },

    characterApplications : {
      handler(data){
        if(typeof data === 'undefined') return;

        for(let characterApplication of data.data){
          this.applicationList.push({
            id  : characterApplication.id
          }); 
        }

        if(typeof data.paginatorInfo !== 'undefined'){
          this.paginateParameters.page      = data.paginatorInfo.currentPage;
          this.paginateParameters.lastPage  = data.paginatorInfo.lastPage;
          this.paginateParameters.total     = data.paginatorInfo.total;
        }

        if(this.applicationList.length === 0){
          this.isVisibleNoContent = true;
        }
      }
    },

    applicationList : {
      handler(data){
        if(data.length === 0){
          this.isVisibleNoContent = true;
        }else{
          this.isVisibleNoContent = false;
        }
      },
      deep: true
    }
  },

  apollo : {
    characterApplications : {
      query : GetCharacterApplicationList,

      variables(){
        return {
          page      : this.paginateParameters.page,
          first     : 10,
          orderBy   : [
            {
              // field : 'created_at',
              column : 'created_at',
              order : 'DESC'
            }
          ]
        };
      },

      fetchPolicy: 'no-cache',

      skip(){
        if(this.paginateParameters.page === null){
          return true;
        }else{
          return false;
        }
      },

      result(){
        this.paginateParameters.loaded = true;
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  methods : {
    handleEnter(){
      this.paginateParameters.page = 1;

      this.calcBoxHeight();
    },

    calcBoxHeight(){
      if(typeof this.$refs.contentBox !== 'undefined'){
        this.boxHeight = this.$refs.contentBox.offsetHeight;
      }
    },

    handleClickItem(characterApplicationId){
      if(this.isDisabled) return;
      
      const newUrlQuery = Object.assign({}, this.$route.query);

      newUrlQuery['character_application_detail_id'] = characterApplicationId;
      newUrlQuery['y'] = window.scrollY;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    }
  },

  async mounted(){
    await this.UXWaiting(1000);

    this.couldVisible = true;

    this.$nextTick(() => {
      this.$parent.$parent.$emit('requestScrollBotom');
      this.isLoading = true;

      let intervalCount = 0;
      
      const intervalId = setInterval(() => {
        intervalCount++;

        if(intervalCount < 3) return;
        
        if(this.paginateParameters.loaded === true){
          clearInterval(intervalId);

          this.isLoading = false;
          this.listViewClass['list-view-visible'] = true;
          
          this.calcBoxHeight();
        }
      }, 1000);
    });
  }
}
</script>

<style lang="scss">
.pa-message-additional-box{
  &-check-application-status{
    border-top:1px solid #aad4c5;
    width:98%;
    margin:0 auto;
    position: relative;

    p.title-balloon{
      margin-top: 8px;
      margin-bottom:10px !important;
      background-color:#8FC1AF;
      color: #547166;
      border-radius: 6px;
      padding:2px 6px;
      text-align: center;
    }

    div.list-view-set{
      position: relative;
      min-height:180px;

      ul.list-view{
        margin:0;
        padding:0;
        list-style: none;
        opacity: 0;

        &-visible{
          opacity:1;
        }
      }

      div.no-content-field{
        position: absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p.text{
          text-align: center;
          color:#709c8d;
          font-size: 1rem;
        }
      }
    }
    
    &-disabled{
      opacity:.5;
    }
  }
}

.pa-message-set{
  &-default{
    .pa-message-additional-box{
      &-check-application-status{
        border-color:#aad4c5;

        p.title-balloon{
          background-color:#8FC1AF;
          color: #547166;
        }

        div.list-view-set{
          div.no-content-field{
            p.text{
              color:#709c8d;
            }
          }
        }
      }
    }
  }

  &-lilica{
    .pa-message-additional-box{
      &-check-application-status{
        border-color:#d4aac2;

        p.title-balloon{
          background-color:#c18fc1;
          color: #71546a;
        }

        div.list-view-set{
          div.no-content-field{
            p.text{
              color:#9c7098;
            }
          }
        }
      }
    }
  }
}
</style>